import { useEffect, useState } from "react";
import { FeatureContext } from "../../Context";
import MyAccount from "./MyAccount";
import { getUser } from "./Services";
import { ChakraProvider } from '@chakra-ui/react';
import Loader from "../../components/loader/Loader";
import { Error } from "../../components/error/Error";
import { NoDataFound } from "../../ErrorType";

const Index = ({ attributes }) => {

  const [state, setState] = useState({
    loader: false,
    error: '',
    user: {},
    setUser: (value) => setState(prevState => ({ ...prevState, user: value })),
    setLoader: {
      on: () => setState(prevState => ({ ...prevState, loader: true })),
      off: () => setState(prevState => ({ ...prevState, loader: false })),
    },
    setError: (value) => setState(prevState => ({ ...prevState, error: value })),
  });

  useEffect(() => {

    state.setLoader.on();

    getUser()
      .then(data => {
        state.setUser(data);
      })
      .catch(error => {
        if (!(error instanceof NoDataFound)) {
          state.setError(error);
        }
      })
      .finally(_ => state.setLoader.off());
  }, []);


  const render = () => {
    if (!!state.error) {
      return <Error error={state.error} />
    } else {
      return <>
        <MyAccount />
      </>
    }
  }

  return <ChakraProvider>
    <FeatureContext.Provider value={state}>
      {(state.loader) ? <Loader /> : render()}
    </FeatureContext.Provider>
  </ChakraProvider>
}

export { Index }